module.exports = __webpack_public_path__ + "img/assign_5.0e181856.png";